import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';

import {AdmisComponent} from './admis.component';
import {admisRoute} from './admis.route';
import {AdmisService} from './admis.service';
import { CalendarModule, RadioButtonModule, SelectButtonModule } from 'primeng/primeng';
import {ReactiveFormsModule} from '@angular/forms';

let ENTITY_STATES = [
    ...admisRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        RouterModule.forRoot(ENTITY_STATES, {useHash: true}),
        RadioButtonModule,
        CalendarModule,
        ReactiveFormsModule,
        SelectButtonModule
    ],
    declarations: [
        AdmisComponent
    ],
    entryComponents: [
        AdmisComponent
    ],
    providers: [
        AdmisService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensAdmisModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/admis/admis.module.ts